import React from 'react';
import { Chart } from 'react-google-charts';

const normalizeAmount = (amount) => {
    if (typeof amount === 'number') {
        return Number.isFinite(amount) ? amount : 0;
    }

    const parsed = Number(String(amount ?? '').replace(/,/g, '').trim());
    return Number.isFinite(parsed) ? parsed : 0;
};

const buildChartData = (dataList) => {
    const rows = Array.isArray(dataList) ? dataList : [];
    const funds = [...new Set(rows.map(row => row?.Fund).filter(Boolean))].sort();
    const dateBuckets = new Map();

    rows.forEach((row) => {
        const cashflowDate = row?.['Cashflow Date'];
        if (!cashflowDate) {
            return;
        }

        const fund = row?.Fund || 'Unknown';
        if (!dateBuckets.has(cashflowDate)) {
            dateBuckets.set(cashflowDate, {});
        }

        const amountsByFund = dateBuckets.get(cashflowDate);
        amountsByFund[fund] = (amountsByFund[fund] || 0) + normalizeAmount(row?.['Cashflow Book Amount']);
    });

    if (funds.length === 0 || dateBuckets.size === 0) {
        return null;
    }

    const sortedDates = [...dateBuckets.keys()].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    const header = ['Cashflow Date', ...funds];
    const dataRows = sortedDates.map((cashflowDate) => {
        const amountsByFund = dateBuckets.get(cashflowDate);
        return [cashflowDate, ...funds.map((fund) => amountsByFund[fund] ?? 0)];
    });

    return [header, ...dataRows];
};

const ProjectionCashflowChart = ({ chartTitle, dataList }) => {
    const chartData = buildChartData(dataList);
    if (!chartData) {
        return <div style={{ padding: '15px' }}>No chart data is available for the selected deal and fund.</div>;
    }

    return (
        <Chart
            chartType="ColumnChart"
            width="100%"
            height="100%"
            data={chartData}
            options={{
                title: chartTitle,
                isStacked: true,
                legend: { position: 'bottom' },
                chartArea: { left: 70, top: 50, right: 20, bottom: 100, width: '100%', height: '100%' },
                hAxis: { slantedText: true, slantedTextAngle: 45 },
                vAxis: {
                    title: 'USD (Millions)',
                    format: 'short'
                },
                backgroundColor: '#ffffff'
            }}
            loader={<div style={{ padding: '15px' }}>Loading chart...</div>}
        />
    );
};

export default ProjectionCashflowChart;
